import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import { connect } from 'react-redux'

import {
    helpers,
    sendHoverSoundCommand,
    sendTabClickSoundCommand,
} from 'react-wot-bootstrap'

import { BATTLE_ROOMS_TAB_STATES, LOCAL_STORAGE_KEYS } from 'constants'
import { BATTLE_ROOMS_TABS } from './constants.jsx'
import { enablePlayerMatching, disablePlayerMatching } from 'state/actions/players_matching'
import { getParsedStorageItem, saveToStorage } from 'helpers/playersMatching'

import styles from './Tabs.scss'

export class Tabs extends React.Component {
    static propTypes = {
        openPlayerMatchingTab: PropTypes.func.isRequired,
        openUnitListTab: PropTypes.func.isRequired,
        selectedTabId: PropTypes.string.isRequired,
    }

    handleTabClick(tabId) {
        sendTabClickSoundCommand()
        if (tabId === BATTLE_ROOMS_TABS[0].id) {
            this.props.openPlayerMatchingTab()
            saveToStorage(LOCAL_STORAGE_KEYS.BATTLE_ROOMS_TAB, BATTLE_ROOMS_TAB_STATES.MATCHING)
        } else if (tabId === BATTLE_ROOMS_TABS[1].id) {
            this.props.openUnitListTab()
            saveToStorage(LOCAL_STORAGE_KEYS.BATTLE_ROOMS_TAB, BATTLE_ROOMS_TAB_STATES.UNITS)
        }
    }

    render() {
        const tabsComponent = BATTLE_ROOMS_TABS.map(tab => {
            const handleClick = () => this.handleTabClick(tab.id)

            const itemClassName = classNames(styles.item, {
                [styles.item__selected]: tab.id === this.props.selectedTabId,
            })

            return (
                <div
                    className={itemClassName}
                    key={tab.id}
                    onClick={handleClick}
                    onMouseEnter={sendHoverSoundCommand}
                >
                    <div className={styles.tab}>
                        <span className={styles.overlay} />
                        <span className={styles.borders} />
                        <span className={styles.caption}>
                            {tab.title}
                        </span>
                    </div>
                </div>
            )
        })

        const className = classNames(styles.base, {
            [styles.base__cn]: helpers.isChineseLanguage(),
        })

        return (
            <div className={className}>
                <div className={styles.holder}>
                    {tabsComponent}
                </div>
            </div>
        )
    }
}

export const mapStateToProps = state => {
    const isUnitsTabStored = getParsedStorageItem(LOCAL_STORAGE_KEYS.BATTLE_ROOMS_TAB) === BATTLE_ROOMS_TAB_STATES.UNITS
    const isUnitsTabSelected = !state.players_matching.active || isUnitsTabStored

    const selectedTabId = isUnitsTabSelected ? BATTLE_ROOMS_TABS[1].id : BATTLE_ROOMS_TABS[0].id

    return { selectedTabId }
}

const mapDispatchToProps = {
    openPlayerMatchingTab: enablePlayerMatching,
    openUnitListTab: disablePlayerMatching,
}

export default connect(mapStateToProps, mapDispatchToProps)(Tabs)



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/Tabs/Tabs.jsx